/** Só os dígitos do texto: tira pontuação e espaço de CPF e telefone. Sem texto, devolve ''. */
export function soDigitos(texto: string | null | undefined): string {
  return (texto ?? '').replace(/\D/g, '')
}
